<template>
  <div v-if="!loading">
    <div class="info--text text-uppercase my-3 mt-2">
      {{ generateMessage('requests.details.titles.exploitation') }}
    </div>
    <div>
      <span class="font-weight-bold">
        {{ generateMessage('requests.details.titles.maintenance') }}
      </span>
      <custom-simple-table
        :item="property"
        i18-path="properties_360.fields"
        :table-keys="[
          'mnt_responsible_technician',
          'mnt_responsible_phone',
          'mnt_resp_buddy',
          'mnt_resp_buddy_phone',
        ]"
      />
      <span class="font-weight-bold">
        {{ generateMessage('requests.details.titles.requests') }}
      </span>
      <custom-simple-table
        :item="property.maintenance"
        i18-path="properties_360.fields.maintenance"
        :table-keys="['tech_in_charge', 'tech_in_charge_phone']"
      />
    </div>
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('properties_360');

export default {
  name: 'property-exploitation',
  components: {
    CustomSimpleTable,
  },
  computed: {
    ...mapGetters({ property: 'current', loading: 'isLoadingCurrent' }),
    data() {
      return {
        ...this.active,
      };
    },
  },
  methods: {
    generateMessage,
  },
};
</script>
